import { Major } from './../builders/major_builder';
import { ITransferMajorsDatasource } from './../datasources/transfer_majors_datasource';
import { ITransferDegreeCompletionDatasource } from '../datasources/transfer_degree_completion_datasource';
import { ICommand, IDefineCommand, IQueryMediator, IQuery, key } from 'core-ts-types';

angular.module('capability-ng-transfer').factory(
  'loadTransferMajorDegreeAuditCommand',
  (
    defineCommand: IDefineCommand,
    QueryMediator: IQueryMediator,
    ngTransferMajorsDatasource: ITransferMajorsDatasource,
    ngTransferDegreeCompletionDatasource: ITransferDegreeCompletionDatasource,
    $http: ng.IHttpService
  ): ICommand => {
    return defineCommand('loadTransferMajorDegreeAuditCommand', function loadTransferMajorDegreeAudit(
      deferred: ng.IDeferred<IQuery[]>,
      majorId: key,
      studentId?: string
    ): void {
      const majors: Record<string, Major> = ngTransferMajorsDatasource.read();
      const major: Major = majors[majorId];
      if (_.get(major, 'preprof_ind', true)) {
        return;
      }

      const auditUrl = studentId
        ? `v2/student/${studentId}/program/${majorId}/audit/`
        : `student/program/${majorId}/audit/`;
      $http({
        method: 'GET',
        url: auditUrl
      })
        .then((response: ng.IHttpPromiseCallbackArg<any>): void => {
          const updatedMajor = _.merge({ id: majorId }, response.data.results);
          ngTransferMajorsDatasource.put(updatedMajor);
          const degreeCompletionId = studentId ? `${studentId}-${majorId}` : majorId;
          const degreeCompletion = _.merge({ degreeCompletionId: degreeCompletionId }, response.data.results);
          ngTransferDegreeCompletionDatasource.put(degreeCompletion);
          deferred.resolve(QueryMediator.runQueries(ngTransferMajorsDatasource, ngTransferDegreeCompletionDatasource));
        })
        .catch((response: ng.IHttpPromiseCallbackArg<any>): void => {
          const HTTP_404_NOT_FOUND = 404;
          if (response.status === HTTP_404_NOT_FOUND) {
            const updatedMajor: Major = _.merge(major, { auditAvailable: false });
            ngTransferMajorsDatasource.put(updatedMajor);
            deferred.resolve(QueryMediator.runQueries(ngTransferMajorsDatasource));
            return;
          }
          deferred.reject();
        });
    });
  }
);



// WEBPACK FOOTER //
// ./app/lib/transfer/commands/load_transfer_major_degree_audit_command.ts